import { useEffect } from "react";
import { ConsiderRefreshingVoiceBooking } from "./RefreshVoiceBooking";
import { ConsiderRefreshingVoiceBookingEta } from "./RefreshVoiceBookingEta";

/** Manages the timer that checks for booking changes. 
 * Each tick of the timer doesn't necessarily cause a refresh: that's managed by RefreshVoiceBooking.ts 
 * The reason we do that is that this timer is only ticking when the user has opened the tracking page. So once they opened the page, we want a tick to occur quickly. */
export const BookingRefreshTimer: React.FC = () => {

    useEffect(() => {
        async function OnTimerTick() {
            await ConsiderRefreshingVoiceBooking();
            await ConsiderRefreshingVoiceBookingEta();
        }

        const timerId = window.setInterval(OnTimerTick, 1000);

        // clear on unmount
        return () => clearInterval(timerId);
    }, []);

    /** This component doesn't render any JSX. It is just using the lifecycle events. */
    return null;
}